import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/84f75d7c-5aa3-41e4-b7ad-dd29b3b984c6/838cdbab-d32d-4b26-b12c-15bffc18506a_poktapok_v1_sin-fondo.png';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-green-700 shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img
                src={LOGO_URL}
                alt="PokTaPok"
                className="h-16 w-auto object-contain cursor-pointer"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-white hover:text-gray-200 transition-colors font-medium">
              Inicio
            </Link>
            <Link to="/nosotros" className="text-white hover:text-gray-200 transition-colors font-medium">
              Nosotros
            </Link>
            <Link to="/contacto" className="text-white hover:text-gray-200 transition-colors font-medium">
              Contacto
            </Link>
            <Link to="/anuncio" className="text-white hover:text-gray-200 transition-colors font-medium">
              Anuncio
            </Link>
            <Link to="/poktatoken" className="text-white hover:text-gray-200 transition-colors font-medium">
              PokTaToken
            </Link>
            <Link to="/asistente-ia" className="text-white hover:text-gray-200 transition-colors font-medium">
              Asistente IA 24/7
            </Link>
          </nav>

          {/* Login Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/login">
              <Button className="flex items-center space-x-2 bg-red-600 text-white hover:bg-red-700" variant="secondary">
                <i className="ri-user-line"></i>
                <span>Iniciar Sesion</span>
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 text-white hover:text-gray-200"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={isMenuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-green-600">
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-white hover:text-gray-200 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Inicio
              </Link>
              <Link 
                to="/nosotros" 
                className="text-white hover:text-gray-200 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Nosotros
              </Link>
              <Link 
                to="/contacto" 
                className="text-white hover:text-gray-200 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Contacto
              </Link>
              <Link 
                to="/anuncio" 
                className="text-white hover:text-gray-200 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Anuncio
              </Link>
              <Link 
                to="/poktatoken" 
                className="text-white hover:text-gray-200 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                PokTaToken
              </Link>
              <Link 
                to="/asistente-ia" 
                className="text-white hover:text-gray-200 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Asistente IA 24/7
              </Link>
              <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                <Button className="flex items-center justify-center space-x-2 w-full bg-red-600 text-white hover:bg-red-700" variant="secondary">
                  <i className="ri-user-line"></i>
                  <span>Iniciar Sesion</span>
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}